window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.Card = window.locales.am.Card || {};window.locales.am.Card.card = window.locales.am.Card.card || {};window.locales.am.Card.card = {...window.locales.am.Card.card, ...{
    "dismiss": "አሰናብት"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.Card = window.locales.ar.Card || {};window.locales.ar.Card.card = window.locales.ar.Card.card || {};window.locales.ar.Card.card = {...window.locales.ar.Card.card, ...{
    "dismiss": "رفض"
}
};window.locales.en = window.locales.en || {};window.locales.en.Card = window.locales.en.Card || {};window.locales.en.Card.card = window.locales.en.Card.card || {};window.locales.en.Card.card = {...window.locales.en.Card.card, ...{
    "dismiss": "Dismiss"
}
};window.locales.es = window.locales.es || {};window.locales.es.Card = window.locales.es.Card || {};window.locales.es.Card.card = window.locales.es.Card.card || {};window.locales.es.Card.card = {...window.locales.es.Card.card, ...{
    "dismiss": "Despedir"
}
};window.locales.it = window.locales.it || {};window.locales.it.Card = window.locales.it.Card || {};window.locales.it.Card.card = window.locales.it.Card.card || {};window.locales.it.Card.card = {...window.locales.it.Card.card, ...{
    "dismiss": "Congedare"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.Card = window.locales.zh.Card || {};window.locales.zh.Card.card = window.locales.zh.Card.card || {};window.locales.zh.Card.card = {...window.locales.zh.Card.card, ...{
    "dismiss": "解雇"
}
};